
// check for global page object or set to object literal

const settings = window.adsPosSettings || {
  adSize: {}
};

export default settings;
